(function () {
  // Font ∩ Mac Roman (223 characters). Trim as suggested earlier if you want a stricter set.
  var DISALLOWED = /[^\u0020-\u007E\u00A0-\u00A3\u00A5\u00A7-\u00AC\u00AE-\u00B1\u00B4-\u00B8\u00BA-\u00BB\u00BF-\u00CF\u00D1-\u00D6\u00D8-\u00DC\u00DF-\u00EF\u00F1-\u00FC\u00FF\u0131\u0152-\u0153\u0178\u0192\u02C6-\u02C7\u02D8-\u02DD\u03A9\u03C0\u2013-\u2014\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2026\u2030\u2039-\u203A\u2044\u20AC\u2122\u2202\u2206\u220F\u2211\u221A\u221E\u222B\u2248\u2260\u2264-\u2265\u25CA\uF8FF\uFB01-\uFB02]/gu;

  function clean(s) {
  return s.normalize('NFC').replace(DISALLOWED, '');
}

function sanitise(input) {
  var v = input.value;
  var c = clean(v);
  if (c === v) return;

  // Keep the caret in the right place: clean only the text before it
  var caret = clean(v.slice(0, input.selectionStart)).length;
  input.value = c;
  input.setSelectionRange(caret, caret);
}

function attach(input) {
  if (input.dataset.fontSafeBound) return;
  input.dataset.fontSafeBound = '1';

  var composing = false;
  input.addEventListener('compositionstart', function () { composing = true; });
  input.addEventListener('compositionend', function () { composing = false; sanitise(input); });

  input.addEventListener('input', function () {
    if (!composing) sanitise(input);   // don't interrupt IME entry (Chinese, Japanese, etc.)
  });
}

  function init(root) {
    (root || document).querySelectorAll('[data-font-safe]').forEach(attach);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  // Re-bind when the theme editor or quick-view re-renders sections
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();